import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'ppl-view-batches',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './view-batches.component.html',
  styleUrl: './view-batches.component.css'
})
export class ViewBatchesComponent {

}
